<script>
  import { onMount } from "svelte";
  let logo = "public/assets/images/SSI_logo_white.png";
</script>

<style>
  .nav-container {
    margin-bottom: 2em;
  }
</style>

<div class="nav-container">
  <div class="nav-logo">
    <img src={logo} alt="Timesheet" width="140px" />
  </div>
</div>
